<template>
  <NavBar v-if="$vuetify.breakpoint.smAndDown">
    <template #buttonsRight>
      <NavBarButtonsRightMobile v-if="is_logged_in"/>
      <v-btn v-else :href="login_url">{{$t('Buttons.Login')}}</v-btn>
    </template>
  </NavBar>
  <NavBar v-else>
    <template #buttonsLeft v-if="is_logged_in">
      <NavigationButton
        text="My Projects"
        icon="domain"
        route="ProjectOverView"/>
      <NavigationButton
        text="WorkBench"
        icon="takt_workbench"
        route="WorkBench"/>
      <NavigationButton
        text="Connect"
        icon="share"
        route="Connect"/>
      <NavigationButton
        ref="test1"
        v-if="hasPermission('Business UPDATE')"
        text="Company"
        icon="takt_company"
        route="Company"
        />
      <NavigationButton
        ref="test2"
        v-if="hasPermission('Stats READ')"
        text="Dashboard"
        icon="dashboard"
        route="Dashboard"
        />
      <NavigationButton
        ref="test3"
        v-if="hasPermission('AI TAKTING')"
        text="AI"
        icon="extension"
        route="AIDashboard"
        />
    </template>
    <template #buttonsMiddle v-if="is_logged_in">
      <ProjectTitle
        v-if="$route.matched[0] && $route.matched[0].name === 'Project'"
        :text="getProject($route.params.project_id).name"
        />
      <EditButton
        v-if="$route.name === 'ProjectTaktPlan'"
        :isEditMode="isEditMode"
        @click.native="isEditMode? leaveEditMode({project_id: $route.params.project_id}):enterEditMode({project_id: $route.params.project_id})"
      />
      <v-btn @click="taktplan_zoom+= 0.1">plus</v-btn>
      <v-btn @click="taktplan_zoom-= 0.1">minus</v-btn>
      <v-slider
      v-model="taktplan_zoom"
        min="0.4"
        max="2"
        step="0.1"
        />
    </template>
    <template #tools>
      <NavBarTools v-if="is_logged_in"/>
    </template>
    <template #switch>
      <NavBarSwitch />
    </template>
    <template #buttonsRight>
      <NavBarButtonsRight v-if="is_logged_in"/>
      <v-btn v-else :href="getLoginUrl">{{$t('AppLayout.NavBar.Login')}}</v-btn>
    </template>
  </NavBar>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

import NavBar from '@/components/AppLayout/NavBar.component.vue'
import NavigationButton from '@/components/AppLayout/NavigationButton.component.vue'
import ProjectTitle from '@/components/AppLayout/ProjectTitle.component.vue'
import EditButton from '@/components/AppLayout/EditButton.component.vue'
import NavBarTools from '@/components/AppLayout/NavBarTools.component.vue'
import NavBarButtonsRight from '@/components/AppLayout/NavBarButtonsRight.component.vue'
import NavBarButtonsRightMobile from '@/components/AppLayout/NavBarButtonsRightMobile.component.vue'
import NavBarSwitch from '@/components/AppLayout/NavBarSwitch.component.vue'
export default {
  props: ['is_logged_in'],
  components: {
    NavBar,
    NavigationButton,
    ProjectTitle,
    EditButton,
    NavBarTools,
    NavBarButtonsRight,
    NavBarButtonsRightMobile,
    NavBarSwitch
  },
  data: () => ({
    taktplan_zoom: 1.1,
  }),
  computed: {
    ...mapGetters('Auth', [
      'hasPermission',
      'getLoginUrl'
    ]),
    ...mapGetters('Project', [
      'getProject', 'isEditMode'
    ]),
  },
  watch: {
    taktplan_zoom: function() {
      document.body.style.setProperty('--taktplan_zoom', `${this.taktplan_zoom}`)
    }
  },
  methods: {
    ...mapActions('Project', [
      'enterEditMode', 'leaveEditMode'
    ]),
    // ...mapActions('Auth', [
    //   'signIn'
    // ])
  }
}
</script>
